import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { UserWithInvitation } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';

import { MenuTypeEnum } from '../../../../core/enums/menu-type.enum';
import { normalizeUserRole, UserRoleType } from '../../../user/constants/teacher-roles.constants';

@Component({
  selector: 'app-user-row',
  templateUrl: './user-row.component.html',
  styleUrls: ['./user-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserRowComponent {
  private readonly translocoService = inject(TranslocoService);

  @Input() set data(value: UserWithInvitation) {
    this.userData = value;
    const normalizedRole = normalizeUserRole(value.role);

    this.displayRole =
      this.translocoService.translate(`users/role/${normalizedRole}`) ||
      this.translocoService.translate(`users/role/${UserRoleType.TEACHER}`);
  }
  @Output() resendInvitation = new EventEmitter<string>();
  @Output() deleteInvitation = new EventEmitter<string>();
  @Output() refreshData = new EventEmitter<void>();

  protected userData: UserWithInvitation = null;
  protected displayRole: string | null = null;

  protected menuTypeEnum = MenuTypeEnum;

  onResend(): void {
    if (this.userData.invitationId) {
      this.resendInvitation.emit(this.userData.invitationId);
    }
  }

  onDelete(): void {
    if (this.userData.invitationId) {
      this.deleteInvitation.emit(this.userData.invitationId);
    }
  }
}
